<div class="page-container">
  <app-page-header title="Menu Items">
    <div class="header-actions" header-actions>
      <p-iconfield iconPosition="left">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input
          pInputText
          placeholder="Search name"
          type="text"
          [(ngModel)]="searchText"
          (keyup.enter)="applyFilters()"
        />
      </p-iconfield>
      <p-autocomplete
        appendTo="body"
        optionLabel="name"
        placeholder="Healthy Gourmet Kitchen"
        [showClear]="true"
        [suggestions]="producerSuggestions()"
        [(ngModel)]="producerFilter"
        (completeMethod)="searchProducers($event)"
        (onClear)="applyFilters()"
      ></p-autocomplete>
      <p-button icon="pi pi-search" label="Apply" severity="primary" size="small" (onClick)="applyFilters()"></p-button>
      <p-button
        icon="pi pi-filter-slash"
        label="Clear"
        severity="secondary"
        [disabled]="!hasActiveFilters()"
        [text]="true"
        (onClick)="clearFilters()"
      ></p-button>
    </div>
  </app-page-header>

  @if (error()) {
    <p-message severity="error" text="Failed to load menu items. Please try again."></p-message>
  }

  <div class="status-tabs">
    <p-selectbutton
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      [ngModel]="statusTabValue()"
      [options]="statusTabs()"
      (ngModelChange)="setStatus($event)"
    ></p-selectbutton>
  </div>

  <p-table
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    dataKey="id"
    [lazy]="true"
    [loading]="loading()"
    [paginator]="true"
    [rows]="pageSize()"
    [rowsPerPageOptions]="[25, 50, 100]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    [sortField]="'submittedAt'"
    [sortOrder]="1"
    [totalRecords]="totalRecords()"
    [value]="rows()"
    (onLazyLoad)="onLazyLoad($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="thumb-col"></th>
        <th pSortableColumn="name">
          Name
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th>Healthy Gourmet Kitchen</th>
        <th pSortableColumn="submittedAt">
          Submitted
          <p-sortIcon field="submittedAt"></p-sortIcon>
        </th>
        @if (showStatusColumn()) {
          <th>Status</th>
        }
      </tr>
    </ng-template>

    <ng-template let-item pTemplate="body">
      <tr class="menu-item-row" (click)="openDetail(item)">
        <td class="thumb-col">
          @if (item.imageUrl) {
            <img class="thumb" appImageFallback [alt]="item.name" [src]="item.imageUrl" />
          } @else {
            <div class="thumb thumb--placeholder">
              <i class="pi pi-image"></i>
            </div>
          }
        </td>
        <td>
          <div class="name-cell">
            <a class="name" [routerLink]="['/menu-items', item.id]" (click)="$event.stopPropagation()">
              {{ item.name }}
            </a>
            @if (showMarketingName(item)) {
              <span class="marketing-name">{{ item.marketingName }}</span>
            }
          </div>
        </td>
        <td>{{ resolveProducerName(item) }}</td>
        <td>
          <span [title]="item.submittedAt ? (item.submittedAt | date: 'medium') : ''">
            {{ formatAge(item.submittedAt) }}
          </span>
        </td>
        @if (showStatusColumn()) {
          <td>
            @if (item.status) {
              <p-tag [severity]="statusSeverity(item.status)" [value]="item.status"></p-tag>
            }
          </td>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty-message-cell" [attr.colspan]="showStatusColumn() ? 5 : 4">
          <p-message severity="info" [text]="emptyMessage()"></p-message>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loadingbody">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <tr>
          <td><p-skeleton height="3rem" width="3rem"></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          @if (showStatusColumn()) {
            <td><p-skeleton></p-skeleton></td>
          }
        </tr>
      }
    </ng-template>
  </p-table>
</div>
